import React, { useEffect, useState } from 'react'
import CardWrapper from '../../../components/molecules/CardWrapper'
import CardHeader from '../../../components/atoms/cardHeader'
import ProductTable from './components/ProductTable'
import CommonSearch from './components/CommonSearch'
import { Pagination } from '../../../components/atoms/pagination'
import { GetProductListing } from '../../../store/thunks/productThunk'
import { useDispatch, useSelector } from 'react-redux'
import TableLoader from '../../../components/atoms/Loader/tableLoader'

const AddProductToInventory = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({ paginationFilter: { offset: 0, limit: 10, order: "DESC" } });
  useEffect(() => {
    if (filters?.text || filters?.companyId || filters?.productDomainId) {
      dispatch(GetProductListing({ filters }))
    }
  }, [filters])

  const { list, pageInfo, loading } = useSelector((state) => state.productListing);

  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <CardWrapper>
        <CardHeader name={"Add Product To Inventory"} tooltipText={"Use this section to add products to your inventory from available product listings"} />

        <div className="card-body p-4">
          <div className="main-area m-auto">
            <CommonSearch filters={filters} setFilters={setFilters} />
            <div className="product-category">
              {/**Final Table After Sub Category Start**/}
              {(filters?.text || filters?.companyId || filters?.productDomainId) && <div className="result-sub-category mt-6">
                {/* {productList && ( */}
                {loading ? <TableLoader /> : <ProductTable productList={list} />}
                {/* )} */}
                <Pagination pageInfo={pageInfo} offset={filters?.paginationFilter?.offset}
                  setOffset={(newOffset) =>
                    setFilters((prev) => ({
                      ...prev,
                      paginationFilter: {
                        ...prev.filters,
                        offset: newOffset,
                      },
                    }))
                  }
                />
              </div>}
              {/**Final Table After Sub Category End**/}

            </div>
          </div>
        </div>
      </CardWrapper>
    </div>
  )
}

export default AddProductToInventory